var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtasks-count"},[_c('CommonIcons',{staticClass:"subtasks-count__icon",attrs:{"id":"subtasks"}}),_vm._v(" "),_c('span',{staticClass:"subtasks-count__number"},[_vm._v(_vm._s(_vm.count))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }